import { FC } from "react";
import Menu from "@material-ui/icons/Menu";
import { IconButton } from "@material-ui/core";
import { useTopHeadStyles } from "./styles";
import { useDispatch } from "react-redux";
import { toggleNavMenu } from "actions/navMenuActions";

interface MobileBurgerButtonProps {}

export const MobileBurgerButton: FC<MobileBurgerButtonProps> = () => {
  const classes = useTopHeadStyles();
  const dispatch = useDispatch();

  return (
    <>
      <IconButton className={classes.menuButton} onClick={() => dispatch(toggleNavMenu())}>
        <Menu />
      </IconButton>
    </>
  );
};
